import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Tabs,
  Tab,
  Card,
  CardContent,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import AddressForm from "./AdddresForm";
import {
  getUserBillingAddress,
  getUserShippingAddress,
} from "services/apiService";
import toast from "react-hot-toast";
import no_address from "../../assect/Images/9264885-removebg.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

interface AddressModuleProps {
  userId: any;
  open: boolean;
  onClose: () => void;
  onBillingCardSelect: (card: any) => void;
  onShippingCardSelect: (card: any) => void;
}

const AddressModule: React.FC<AddressModuleProps> = ({
  userId,
  open,
  onClose,
  onBillingCardSelect,
  onShippingCardSelect,
}) => {
  const [userbillingAddresses, setUserbillingAddresses] = useState([]);
  const [usershippingAddresses, setUsershippingAddresses] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [selectedCard, setSelectedCard] = useState<any | null>(null);
  const [selectedCardShipping, setSelectedCardShipping] = useState<any | null>(
    null
  );

  useEffect(() => {
    fetchAddressDetails();
  }, [userId]);

  const fetchAddressDetails = async () => {
    if (!userId) return;

    const apiCalls = [
      {
        fetchFunction: () => getUserBillingAddress(userId),
        setState: setUserbillingAddresses,
      },
      {
        fetchFunction: () => getUserShippingAddress(userId),
        setState: setUsershippingAddresses,
      },
    ];

    try {
      await Promise.all(
        apiCalls.map(async ({ fetchFunction, setState }) => {
          const response = await fetchFunction();
          if (response?.status_code === 200) {
            setState(response.data);
          } else if (response?.data === null) {
            setState(null);
          }
        })
      );
    } catch (error) {
      toast.error("An error occurred while fetching user data.");
      console.error(error);
    }
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleCardSelect = (card: any) => {
    setSelectedCard(card);
    onBillingCardSelect(card);
  };

  const handleDeselect = () => {
    setSelectedCard(null);
    onBillingCardSelect(null);
  };

  const handleshippingCardSelect = (card: any) => {
    setSelectedCardShipping(card);
    onShippingCardSelect(card);
  };

  const handleshippingDeselect = () => {
    setSelectedCardShipping(null);
    onShippingCardSelect(null);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "60%",
          height: "85vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 2,
          borderRadius: 2,
          overflow: "auto",
        }}
      >
        <IconButton
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 1000,
          }}
          onClick={onClose}
        >
          <FontAwesomeIcon icon={faXmark} />
        </IconButton>

        <Tabs value={tabValue} onChange={handleTabChange} centered>
          <Tab label="Billing Addresses" />
          <Tab label="Shipping Addresses" />
          <Tab label="Create Billing" />
          <Tab label="Create Shipping" />
        </Tabs>

        {/* Tab Content */}
        <Box sx={{ mt: 2 }}>
          {tabValue === 0 && (
            <Box
              sx={{
                display: "grid",
                gap: 2,
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              }}
            >
              {userbillingAddresses && userbillingAddresses.length > 0 ? (
                userbillingAddresses.map((item) => (
                  <Card
                    key={item.billing_address_id}
                    sx={{
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      borderRadius: "3px",
                      position: "relative",
                      border:
                        selectedCard?.billing_address_id ===
                        item.billing_address_id
                          ? "2px solid #1976d2"
                          : "2px solid transparent",
                      transition: "border 0.3s ease",
                    }}
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: "bold",
                            color: "#333",
                            textTransform: "uppercase",
                          }}
                        >
                          {item?.billing_name}
                        </Typography>
                        <hr />
                        <Typography variant="body2" sx={{ color: "#555" }}>
                          <strong>Email:</strong> {item.billing_email}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#555" }}>
                          <strong>Phone:</strong> {item.billing_phone_no}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#555" }}>
                          <strong>Address:</strong>{" "}
                          {item.billing_address_line_one},{" "}
                          {item.billing_address_line_two}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#555" }}>
                          <strong>City:</strong> {item.billing_city},{" "}
                          <strong>State:</strong> {item.billing_state},{" "}
                          <strong>Country:</strong> {item.billing_country}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#555" }}>
                          <strong>Pincode:</strong> {item.billing_pincode}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#555" }}>
                          <strong>Default:</strong>{" "}
                          {item.billing_set_default ? "Yes" : "No"}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          mt: 1,
                        }}
                      >
                        {selectedCard?.billing_address_id ===
                        item.billing_address_id ? (
                          <Button
                            variant="outlined"
                            size="small"
                            color="error"
                            onClick={handleDeselect}
                          >
                            Deselect
                          </Button>
                        ) : (
                          <Button
                            variant="contained"
                            size="small"
                            onClick={() => handleCardSelect(item)}
                          >
                            Select
                          </Button>
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                ))
              ) : (
                <Typography
                  variant="body1"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    flexDirection: "column",
                    mt: 2,
                  }}
                >
                  <img src={no_address} width={500} alt="no_adddress" />
                  No billing data available.
                </Typography>
              )}
            </Box>
          )}

          {tabValue === 1 && (
            <Box
              sx={{
                display: "grid",
                gap: 2,
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              }}
            >
              {usershippingAddresses && usershippingAddresses.length > 0 ? (
                usershippingAddresses.map((item) => (
                  <Card
                    key={item.shipping_address_id}
                    sx={{
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      borderRadius: "8px",
                      position: "relative",
                      border:
                        selectedCardShipping?.shipping_address_id ===
                        item.shipping_address_id
                          ? "2px solid #1976d2"
                          : "2px solid transparent",
                      transition: "border 0.3s ease",
                    }}
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: "bold", color: "#333" }}
                        >
                          {item?.shipping_name}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#555" }}>
                          <strong>Email:</strong> {item.shipping_email}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#555" }}>
                          <strong>Phone:</strong> {item.shipping_phone_no}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#555" }}>
                          <strong>Address:</strong>{" "}
                          {item.shipping_address_line_one},{" "}
                          {item.shipping_address_line_two}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#555" }}>
                          <strong>City:</strong> {item.shipping_city},{" "}
                          <strong>State:</strong> {item.shipping_state},{" "}
                          <strong>Country:</strong> {item.shipping_country}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#555" }}>
                          <strong>Pincode:</strong> {item.shipping_pincode}
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#555" }}>
                          <strong>Default:</strong>{" "}
                          {item.shipping_set_default ? "Yes" : "No"}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          mt: 2,
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {selectedCardShipping?.shipping_address_id ===
                        item.shipping_address_id ? (
                          <Button
                            variant="outlined"
                            size="small"
                            color="error"
                            onClick={handleshippingDeselect}
                          >
                            Deselect
                          </Button>
                        ) : (
                          <Button
                            variant="contained"
                            size="small"
                            onClick={() => handleshippingCardSelect(item)}
                          >
                            Select
                          </Button>
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                ))
              ) : (
                <Typography
                  variant="body1"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    flexDirection: "column",
                    mt: 2,
                  }}
                >
                  <img src={no_address} width={500} alt="no_adddress" />
                  No shipping data available.
                </Typography>
              )}
            </Box>
          )}
          {tabValue === 2 && (
            <AddressForm
              type="billing"
              userId={userId}
              onAutoComplete={fetchAddressDetails}
            />
          )}
          {tabValue === 3 && (
            <AddressForm
              type="shipping"
              userId={userId}
              onAutoComplete={fetchAddressDetails}
            />
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default AddressModule;
